import $ from "jquery";
import uly from "ulysses/base";
import Navigation from "ulysses/navigation";
import ko from "knockout";
import ResizeObserver from "resize-observer-polyfill";
import HalResource from "ulysses/api";
import URI from "URI/URI";
import Globalize from "globalize";
import "adminlte";
import "ulysses/page";
import "ulysses/pubsub";

"use strict";
if (!console.debug){
    console.debug = console.worning = console.info;
}

$.extend(uly, {
    $: $,
    classes :{
        3:"col-xs-12 col-sm-6 col-md-6 col-lg-3 clearfix",
        6:"col-xs-12 col-sm-12 col-md-12 col-lg-6 clearfix",
        9:"col-xs-12 col-sm-12 col-md-12 col-lg-9 clearfix",
        12:"col-xs-12 col-sm-12 col-md-12 col-lg-12 clearfix",
        left:   "col-xs-12 col-sm-8 col-md-8 col-lg-5 clearfix column",
        middle: "col-xs-12 col-sm-8 col-md-8 col-lg-5 clearfix column",
        right:  "col-xs-12 col-sm-4 col-md-4 col-lg-2 clearfix column pull-right"
    },
    ui: {
        //observable that gets resolved when our good friend is inistialised
        started: Promise.Deferred()
    },
    history : new Navigation(),
    //sidebar : new Sidebar(),
    initialise_apis: function(root_url, web_socket_url, initial_settings, api_root) {
        uly.root = root_url;
        uly.url_root = root_url;
        uly.api_root = api_root;
        uly.api.reset(api_root +"api/", "v2");
        if (web_socket_url === ":root") {
            uly.web_socket_url = api_root;
        } else {
            uly.web_socket_url = web_socket_url;
        }
        if (uly.web_socket_url && uly.web_socket_url.endsWith("/")) {
            uly.web_socket_url = uly.web_socket_url.slice(0, uly.web_socket_url.length - 1);
        }
    uly.api.routes = {"admin":"admin" };
        uly.settings = initial_settings;


        if (typeof uly.history == "function")
            uly.history = new uly.history();

        if (uly.web_socket_url) {
            uly.setup_web_socket(uly.web_socket_url + "/uly");
        }
    },
    initialise_profile: function(profile) {
        uly.api.clear_entity_cache();
        if (profile) {
            //var master_props = ["username", "fullname", "home_page", "account", "roles", "picture", "email"];
            $.each(profile, function(key,val) {
                if (typeof uly.page.userprofile[key] == "function") {
                    uly.page.userprofile[key](val);
                }
                else
                {
                    uly.page.userprofile[key] = val;
                }
            });
            if (profile.language) {
                $("body").attr("lang", profile.language);
            }
        }
        if (ko.unwrap(uly.page.userprofile.unique_id)) {
            var new_account = "/" + ko.unwrap(uly.page.userprofile.unique_id).replace("#", "/");
            if (ko.isObservable(uly.page.userprofile.account)) {
                uly.page.userprofile.account(new_account);
            } else {
                uly.page.userprofile.account = new_account;
            }
        }
    },
    start_ui: function(app_data) {
        this.page.update_app_settings(app_data);
        var tmp_state = uly.history.get_temporary_state(document.location);
        uly.page.reload(tmp_state);
        uly.ui.started.resolve();
    },
    initialise_app: function(root_url, home_page, profile, web_socket_url, initial_settings, api_root) {
        this.initialise_apis(root_url, web_socket_url, initial_settings, api_root);
        this.initialise_profile(profile);
        this.start_app();
    },
    update_ulysses: function update_ulysses(app_data, auth_data, variant) {
        if (uly.web_socket_url != app_data.web_socket_url) {
            this.initialise_apis(
                uly.root,
                app_data.web_socket_url,
                {},
                uly.api_root
            );
        }
        this.initialise_profile(auth_data);
        uly.settings_variant = variant;
        var tmp_state = uly.history.get_temporary_state(document.location);
        uly.page.reload(tmp_state);
    },
    localise_ulysses: function localise_ulysses(app_data) 
    {
        var app_resource = HalResource(app_data);
        return app_resource.follow("uly:localisation").then(function(localisation_data) {

            uly.strings = localisation_data.strings || {};
            if (localisation_data.locale) {
                if (localisation_data.locale.languages) {
                    var locales = $.map(localisation_data.locale.languages, function(val) {
                        return "cultures/globalize.culture."+val;
                    });
                    locales.splice(0,0,"globalize");
                    //require(locales, function(Globalize) {
                    //    window.Globalize.culture(localisation_data.locale.languages);
                    //});
                    require(["cultures/globalize.culture.it"], function(locale) {
                        Globalize.addCultureInfo(locale)
                    });
                    var date_locale = localisation_data.locale.date_locale ? localisation_data.locale.date_locale : "en-GB";
                    var datetime_locale = localisation_data.locale.datetime_locale ?
                        localisation_data.locale.datetime_locale : "en-GB";
                    var time_locale = localisation_data.locale.time_locale ?
                        localisation_data.locale.time_locale : "en";
                    if (date_locale != "en") {
                        //en (US) is default and isn't in separate file
                        if (date_locale == "en-IE") {
                            require(["jquery", "i18n/jquery.ui.datepicker-en-GB"], function($,dl) {
                            });

                        } else {
                            require(["jquery", "i18n/jquery.ui.datepicker-"+date_locale], function($,dl) {
                            });

                        }
                    }
                    if (time_locale !== "en") {
                        //en is default and isn't in separate file
                        require(["jquery", "i18n/jquery-ui-timepicker-"+time_locale], function($,dl) {
                        });
                        var wysi_locale = time_locale;
                        if (wysi_locale == "de") {
                            wysi_locale = "de-DE";
                        } else if (wysi_locale == "fr") {
                            wysi_locale = "fr-FR";
                        } else if (wysi_locale == "it") {
                            wysi_locale = "it-IT";
                        }
                        if (wysi_locale != "en") {
                            require(["jquery", "bootstrap/locales/wysihtml5/bootstrap-wysihtml5."+wysi_locale], function($,dl) {
                                $.fn.wysihtml5.defaultOptions.locale = wysi_locale;
                            });
                        }

                    }
                    if (time_locale == "de") {
                        require(["moment", "i18n/moment/de", "i18n/fullcalendar/de"], function(moment, dl) {
                            moment.locale("de");
                            Globalize.culture("de");
                        });
                    } else if (time_locale == "it") {
                        require(["moment", "i18n/moment/it"/*, "i18n/fullcalendar/it"*/], function(moment, dl) {
                            moment.locale("it");
                            Globalize.culture("it");
                            // uly.$.fullCalendar.locale("it");
                        });
                        //TODO: HACK For ITALIAN
                        $.extend($.validator.messages, {
                                required: "Campo obbligatorio",
                                remote: "Controlla questo campo",
                                email: "Inserisci un indirizzo email valido",
                                url: "Inserisci un indirizzo web valido",
                                date: "Inserisci una data valida",
                                dateISO: "Inserisci una data valida (ISO)",
                                number: "Inserisci un numero valido",
                                digits: "Inserisci solo numeri",
                                creditcard: "Inserisci un numero di carta di credito valido",
                                equalTo: "Il valore non corrisponde",
                                extension: "Inserisci un valore con un&apos;estensione valida",
                                maxlength: $.validator.format("Non inserire pi&ugrave; di {0} caratteri"),
                                minlength: $.validator.format("Inserisci almeno {0} caratteri"),
                                rangelength: $.validator.format("Inserisci un valore compreso tra {0} e {1} caratteri"),
                                range: $.validator.format("Inserisci un valore compreso tra {0} e {1}"),
                                max: $.validator.format("Inserisci un valore minore o uguale a {0}"),
                                min: $.validator.format("Inserisci un valore maggiore o uguale a {0}"),
                                nifES: "Inserisci un NIF valido",
                                nieES: "Inserisci un NIE valido",
                                cifES: "Inserisci un CIF valido",
                                currency: "Inserisci una valuta valida"
                        });
                        
                    } else if (time_locale == "en" && date_locale == "en-IE") {
                        require(["moment", "i18n/moment/en-gb"/*, "i18n/fullcalendar/en-ie"*/], function(moment, dl) {
                            moment.locale("en-gb");
                            Globalize.culture("en-ie");
                            // uly.$.fullCalendar.locale("en-ie");
                        });

                    } else {
                        Globalize.culture("en")
                    }
                }
            }
            return localisation_data;
        });
    },
    load_modules: function(app_data) {
        
        return HalResource(app_data).follow("uly:modules").then(function(modules) {
            var scripts = modules.scripts.map((value) => {
                var mod = value[0];
                var file = value[1];
                if(mod == "rpc") {
                    return uly.root + "rpc/" + file;
                } else if (mod && file) {
                    return uly.root + mod + "/" + file;
                }
            });
            var def = Promise.Deferred();
            def.resolve();
            //app initialised. now load modules and require them
            //require(scripts, function() {
            //    def.resolve();
            //});
            return def.promise();
        });
    },
    start_ulysses: function start_ulysses(app_data, auth_data, variant, dont_navigate) {
        uly.initialise_apis(
            uly.root,
            app_data.web_socket_url,
            {},
            uly.api_root
        );

        uly.initialise_profile(auth_data);
        $(".modal-body").remove();

        //for desktop set settings variant to desktop
        uly.settings_variant = variant;

        //uly.start_ui(app_data);
        var localisation = uly.localise_ulysses(app_data).then((localisation_data) => {
            setTimeout(() => { 
                //after all this, we force refresh of our sidebars.
                var sb = uly.page.app_settings.sidebar();
                if (sb) {
                    uly.page.app_settings.sidebar(false);
                    uly.page.app_settings.sidebar(true);
                }
                if (uly.page.app_settings.rightsidebar()) {
                    uly.page.app_settings.rightsidebar(false);
                    uly.page.app_settings.rightsidebar(true);
                }
            }, 0);
        });
        var modules = uly.load_modules(app_data);
        Promise.when(localisation, modules).always(function() {
            uly.start_ui(app_data);
            console.log("auth_data:", auth_data, "app_data:", app_data);
            if (auth_data && auth_data.password_expiry !== null && auth_data.password_expiry <= 0) {
                uly.actions.navigateto("/resetmypassword");
                return;
            }
            if (dont_navigate !== true) {
                var state = uly.history.get_parsed_state();
                var fragment = state.fragment || "";
                var requested_url = state.query_data.url;
                if (fragment.indexOf("/") == 0) fragment = fragment.substring(1);
                if (!auth_data) {

                    if (fragment == "" || (fragment && fragment.indexOf("login") == 0 ))
                        uly.actions.login();
                } else {
                    if (fragment && 
                          (fragment.indexOf("login") == 0  || 
                           fragment.indexOf("signed_up") == 0 || 
                           fragment.indexOf("/index.html") > 0 ||
                           fragment.indexOf("impersonate") == 0))
                    {
                        if (requested_url)
                            uly.actions.navigateto(requested_url);
                        else uly.actions.gohome();
                    }
                }
            }
        });
    },
    goTo: function(url, parameters) {
        if (parameters && Object.isObject(parameters)) {

            var uri = new URI(uly.history.get_temporary_state(url).cleanUrl);
            uri.addQuery(parameters);
            url = uri.toString();
        }
        uly.publish("history.pushstate", uly.history.get_temporary_state(url));                            
    },
});

var last_id = 1;
ko.bindingHandlers.toggleoffcanvas = {
    init: function(elt) {
        var id =$(elt).attr("id");
        if (!id) {
            id = "toc_"+last_id;
            $(elt).attr("id", id);
            last_id++;
        }

        uly.ui.started.then(function() {
            if ($.AdminLTE) {
                //Remove me: 2.3 compat
                $.AdminLTE.pushMenu.activate("#"+id);
            } else if ($.fn.pushMenu) {
                $("#" + id).pushMenu();
            } else if ($.fn.PushMenu) {
                $("#" + id).PushMenu();
            } else {
                console.error("No push menu found, cannot activate toggle offcanvas");
            }
        });
    }
};
ko.bindingHandlers.togglecontrolsidebar = {
    init: function(elt) {
        var id =$(elt).attr("id");
        if (!id) {
            id = `toc_${last_id}`;
            $(elt).attr("id", id);
            last_id++;
        }

        uly.ui.started.then(function() {
            if ($.AdminLTE) {
                $.AdminLTE.options.controlSidebarOptions.toggleBtnSelector = `#${id}`;
                $.AdminLTE.controlSidebar.activate();
            } else if ($.fn.controlSidebar) {
                $(`#${id}`).controlSidebar( { slide: false, controlSidebarSlide: false });
            } else if ($.fn.ControlSidebar) {
                $(`#${id}`).data("controlSidebarSlide", false);
                $(`#${id}`).ControlSidebar("collapse");// { slide: false, controlSidebarSlide: false });
            } else {
                console.error("No control sidebar found, cannot activate toggle control sidebar");
            }
            var rightSidebar = $(".control-sidebar")[0];
            var $body = $("body");
            const ro = new ResizeObserver((entries, observer) => {
                console.log("RO control sidebar");
                if ($.AdminLTE) {
                    for (const entry of entries) {
                        $.AdminLTE.layout.fix();
                    }
                } else if ($.fn.layout) {
                    $body.layout("fix");
                } else if ($.fn.Layout) {
                    $body.Layout("fixLayoutHeight");
                } else {
                    console.error("No layout found, cannot fix body layout");
                }
            });
            ro.observe(rightSidebar);
        });
    }
};
ko.bindingHandlers.loaderUntilStarted = {
    init: function(elt) {
        uly.ui.started.then(function() {
            $(elt).children(".loader").hide();
            $(elt).children(".showAfterStarted").show().removeClass("showAfterStarted");
        });
    }
};
//$.AdminLTE.options.enableControlSidebar = false;
